
export default {
  name: 'order',
  path: '/my/order',
  component: () => import('@/views/order'),
  children: [
    {
      name: 'order-edit', // 填写订单
      path: 'edit',
      meta: {
        auth: true
      },
      component: () => import('@/views/order/edit')
    },
    {
      name: 'order-index', // 我的订单
      path: 'index',
      meta: {
        auth: true
      },
      component: () => import('@/views/order/manage')
    },
    {
      name: 'order-detail', // 订单详情
      path: 'detail',
      meta: {
        auth: true
      },
      component: () => import('@/views/order/detail')
    },
    {
      name: 'order-sing', // 签收单详情
      path: 'sign',
      meta: {
        auth: true
      },
      component: () => import('@/views/order/sign')
    },
    {
      name: 'self-order-sign', // 自营签收单
      path: 'self_sign',
      meta: {
        auth: true
      },
      component: () => import('@/views/order/self-sign')
    },
    {
      name: 'back/self-order-sign', // 回退自营签收单
      path: 'self_sign/back',
      meta: {
        auth: true
      },
      component: () => import('@/views/order/back-sign')
    },
    {
      name: 'back/self-order-sign', // 回退自营签收单
      path: 'self_sign/back',
      meta: {
        auth: true
      },
      component: () => import('@/views/order/back-sign')
    },
    {
      name: 'self-order-sign-detail', // 自营签收单详情
      path: 'self_sign/:id',
      meta: {
        auth: true
      },
      component: () => import('@/views/order/self-sign-detail')
    },
    {
      name: 'replaced-self-auth', // 获取权限校验
      path: 'auth',
      meta: {},
      component: () => import('@/views/order/auth')
    },
    {
      name: 'replaced-self-order-sign', // 自营签收单
      path: 'replaced/self_sign',
      meta: {
      },
      component: () => import('@/views/order/replaced/self-sign')
    },
    {
      name: 'replaced-back-self-order-sign', // 代回退自营签收单
      path: 'replaced/self_sign/back',
      meta: {
      },
      component: () => import('@/views/order/replaced/back-sign')
    },
    {
      name: 'replaced-self-order-sign-detail', // 代自营签收单详情
      path: 'replaced/self_sign/:id',
      meta: {
      },
      component: () => import('@/views/order/replaced/self-sign-detail')
    },
    {
      name: 'replaced-self-order-sign-success', // 代自营签收单详情
      path: 'replaced/sign_success',
      meta: {
      },
      component: () => import('@/views/order/replaced/sign-success')
    },
    {
      name: 'order-protocol', // 供货协议下载，不需要权限
      path: 'protocol',
      component: () => import('@/views/order/protocol')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/order.js